module.exports = __webpack_public_path__ + "img/TataSky.d300532b.png";